import api from './api';

const SchoolUserService = {
  getAll: async (params = {}) => {
    try {
      const response = await api.get('/school-users/', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getTeachers: async (params = {}) => {
    try {
      const response = await api.get('/school-users/', {
        params: { ...params, role: 'TEACHER' }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getById: async (id) => {
    try {
      const response = await api.get(`/school-users/${id}/`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  create: async (data) => {
    try {
      const response = await api.post('/school-users/', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  update: async (id, data) => {
    try {
      const response = await api.put(`/school-users/${id}/`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  partialUpdate: async (id, data) => {
    try {
      const response = await api.patch(`/school-users/${id}/`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await api.delete(`/school-users/${id}/`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getTeacherAssignments: async (params = {}) => {
    try {
      const response = await api.get('/teacher-subjects/', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getTeacherStudents: async (params = {}) => {
    try {
      const response = await api.get('/teacher-students/', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getStudentAttendanceStats: async (enrollmentId) => {
    try {
      const response = await api.get('/students/attendance-stats/', {
        params: { enrollment_id: enrollmentId }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default SchoolUserService;
